import { StatePreV12, StateV12 } from './12_migrate_warenkorb_produktId.interface';

export const migrateAusgewahlteWarenkorbProduktId = (
  previousState: StatePreV12,
  newVersion: number,
): StateV12 => {
  const migratedWarenkorb = previousState.warenkorb.map(angebot => {
    const result = {
      ...angebot,
      appId: angebot.produktId,
    };
    delete result.produktId;
    return result;
  });
  return {
    ...previousState,
    version: newVersion,
    warenkorb: migratedWarenkorb,
  } as StateV12;
};
